import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiRequest from 'utils/apiRequest';
import { LOGIN } from 'apis'; 
import { handleChangeInputLoginPage } from 'reduxx/actions/pages/user/login';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeTimerTimePageVerification, handleChangeInputVerificationPage } from "reduxx/actions/pages/user/verification";

const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mobile } = useSelector(state => state.login);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputMobilePageLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "mobile", value: event} : event.target;
        dispatch(handleChangeInputLoginPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    const handleSubmitFormLogin = (event) => {
        event.preventDefault();

        if(mobile.length !== 11) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل باید 11 رقم باشد', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: LOGIN,
                    method: 'post',
                    data: { mobile },
                    token: null,
                    successMessage: null,
                    onSuccess: (res) => {
                        dispatch(handleChangeTimerTimePageVerification(parseInt(res.timer_time)));
                        dispatch(handleChangeInputVerificationPage('code', ''));
                        navigate(`verify`);
                    },
                });
            }

        }
    };

    return (
        
        <div className={sharedStyles.container}>

        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={[formStyles.title, formStyles['text-center']].join(' ')}>به دکتر بیست خوش آمدید</div>
	            <div className={[formStyles['title-2'], formStyles['text-center']].join(' ')}>جهت ورود، شماره موبایل خود را وارد فرمایید</div>
	            <input type="tel" name="mobile" value={mobile} onChange={handleChangeInputMobilePageLogin} className={formStyles.input} placeholder="شماره موبایل" />
	            <button onClick={handleSubmitFormLogin} className={formStyles.button}>دریافت کد تایید</button>
        	</div>
	            
        </div>

    );
}

export default Login;